import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import moment from 'moment';
import axios from 'axios';
//layouts components
import head from './components/layout/Cabezera.vue'
import Asid from './components/layout/Derecha.vue'
import Foot from './components//layout/Pie.vue'
import Transactions from './components/partials/transactions.vue'
import TransactionsLogs from './components/partials/transactionLog.vue'
import VueGoodTable from 'vue-good-table'
import vuexI18n from 'vuex-i18n'
import VueKnobControl from './components/partials/knob.vue'

Vue.config.productionTip = false

Vue.use(VueGoodTable);
Vue.use(VueKnobControl);
Vue.component('knob-control', VueKnobControl)
Vue.component('Cabezera', head)
Vue.component('Derecha', Asid)
Vue.component('TransactionsLogs', TransactionsLogs)
Vue.component('Transactions', Transactions)
Vue.component('Pie', Foot)
Vue.use(vuexI18n.plugin, store)

// add translations directly to the application
Vue.i18n.add('en', require('./i18n/en.json'));
Vue.i18n.add('es', require('./i18n/es.json'));

// set the start locale to use
//Vue.i18n.set('en');
let lang = localStorage.getItem('lang');

if (Vue.i18n.localeExists(lang)) {

  Vue.i18n.set(lang);
  axios.defaults.headers.common.lang = Vue.i18n.locale();

} else {

  if (Vue.i18n.localeExists((window.navigator.language).substring(0, 2))) {
    Vue.i18n.set((window.navigator.language).substring(0, 2));
    axios.defaults.headers.common.lang = Vue.i18n.locale();
  } else {
    Vue.i18n.set('es');
    axios.defaults.headers.common.lang = Vue.i18n.locale();
  }

}

Vue.filter('Decimal', number => {
  return '$' + parseFloat(number).toFixed(2);
})

Vue.filter('formatDate', value => {
  if (value) {
    return moment(String(value)).locale(Vue.i18n.locale()).format('LLL')
  }
})

Vue.filter('unixTime', value => {
  if (value) {
    return moment(String(value) * 1000).locale(Vue.i18n.locale()).format('LLL')
  }
})
Vue.filter('milliseconds', value => {
  if (value) {

    return moment(String(value) * 100).locale(Vue.i18n.locale()).format('hh:mm:ss');
  }
})

Vue.filter('checkStatus', estatus => {
  if (estatus == "Sin-peticion") return "fa fa-circle-o-notch text-blue";
  if (estatus == "Pendiente") return "fa fa-circle-o-notch text-yellow";
  if (estatus == "Aprobado") return "fa fa-circle-o-notch text-green";
  if (estatus == "Rechazado") return "fa fa-circle-o-notch text-red";
})
/* eslint-disable no-new */

import "./assets/bower_components/jquery/dist/jquery.min.js";
import "./assets/bower_components/jquery-ui/jquery-ui.min";
import "./assets/bower_components/bootstrap/dist/js/bootstrap.min.js"
//import "./assets/bower_components/raphael/raphael.min.js";
import "./assets/bower_components/datatables.net/js/jquery.dataTables.min.js";
//import "./assets/bower_components/morris.js/morris.min.js";
import "./assets/bower_components/jquery-sparkline/dist/jquery.sparkline.min.js";
//import "./assets/plugins/jvectormap/jquery-jvectormap-1.2.2.min.js";
//import "./assets/plugins/jvectormap/jquery-jvectormap-world-mill-en.js";
import "./assets/bower_components/jquery-knob/dist/jquery.knob.min.js";
//import "./assets/bower_components/moment/min/moment.min";
//import "./assets/bower_components/bootstrap-daterangepicker/daterangepicker.js";
import "./assets/bower_components/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
//import "./assets/plugins/bootstrap-wysihtml5/bootstrap3-wysihtml5.all.min.js";
import "./assets/bower_components/jquery-slimscroll/jquery.slimscroll.min.js";
import "./assets/bower_components/fastclick/lib/fastclick.js";
import "./assets/dist/js/pages/dashboard.js";
import "./assets/dist/js/demo.js";
import "./assets/plugins/iCheck/icheck.min.js";
import "./assets/dist/js/adminlte.min.js";

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js